import TrafficDensity from './TrafficDensity';
import FootfallTrend from './FootfallTrend';
import styles from './ChartsRow.module.css';

export default function ChartsRow() {
  return (
    <div className={styles.row}>
      <FootfallTrend />
      <TrafficDensity />
    </div>
  );
}
